module.exports = __webpack_public_path__ + "infocentrum1.jpg?74805599e43948c2682e50c4531d2912";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum1.jpg
// module id = 253
// module chunks = 0